import { BaseAPI } from "@utils/base-api";
import { SerialType } from "@utils/types";
import { AxiosHeaders } from "axios";

import {
  CATS_CUSTOMER_UPDATE_DETAILS_PATH,
  CATS_CUSTOMER_GET_ALL_PATH,
  CATS_CUSTOMER_CREATE_PATH,
} from "./constants/endpoints/customer";
import {
  CATS_ABANDONED_CART_CUSTOMER_FRESH_PATH,
  CATS_ABANDONED_CART_PUBLIC_FRESH_PATH,
} from "./constants/endpoints/abandoned-cart";
import {
  IUpdateCatDetailsRequest,
  IUpdateCatDetailsResponse,
} from "./types/update-cat.types";
import {
  IGetCustomerCatsParams,
  IGetCustomerCatsResponse,
  SubscriptionFilter,
} from "./types/cat-info.types";
import {
  IFreshCreateOrUpdateCatsRequest,
} from "./types/abandoned-cart/abandoned-cart-request.types";
import {
  ICreateOrUpdateCatsResponse,
} from "./types/abandoned-cart/abandoned-cart-response.types";
import {
  ICreateCatRequest,
  TCreateCatResponse,
} from "./types/create-cat.types";

export class CatsAPI extends BaseAPI {

  public async getCats({
    filterSubscription,
    showSuppressedCats,
    headers,
  }: {
    headers?: AxiosHeaders,
    filterSubscription?: SubscriptionFilter,
    showSuppressedCats?: boolean,
  }): Promise<IGetCustomerCatsResponse> {
    const params: IGetCustomerCatsParams = {
      showSuppressedCats,
      filterSubscription,
    };
    return this.getWithTransform<IGetCustomerCatsResponse>(
      CATS_CUSTOMER_GET_ALL_PATH,
      {
        params,
        headers,
      },
      {
        dateFields: [
          "birthday",
        ],
      },
    );
  }

  /**
   * Updates the cat details for a customer.
   *
   * @param data - The data to update the cat details with.
   * All data except id is optional and nullable.
   * @returns The full cat details after the update.
   */
  public async updateCatDetails(data: IUpdateCatDetailsRequest): Promise<SerialType<IUpdateCatDetailsResponse>> {
    const result = await this.axios.patch(
      CATS_CUSTOMER_UPDATE_DETAILS_PATH,
      data,
    );

    return result.data;
  }

  public async createOrUpdateAbandonedCartCats(data: IFreshCreateOrUpdateCatsRequest):
  Promise<ICreateOrUpdateCatsResponse> {
    const result = await this.axios.post(
      CATS_ABANDONED_CART_PUBLIC_FRESH_PATH,
      data,
    );

    return result.data;
  }

  public async createCatDetails(data: IFreshCreateOrUpdateCatsRequest):
  Promise<ICreateOrUpdateCatsResponse> {
    const result = await this.axios.post(
      CATS_ABANDONED_CART_CUSTOMER_FRESH_PATH,
      data,
    );

    return result.data;
  }

  public async createCat(data: ICreateCatRequest):
  Promise<TCreateCatResponse> {
    const result = await this.axios.post(
      CATS_CUSTOMER_CREATE_PATH,
      data,
    );

    return result.data;
  }

}
